import { MetricsInstance } from '@/shared/Metrics';

export default defineNuxtPlugin({
  name: 'metrics',

  setup() {
    const metricsInstance = MetricsInstance.instance;

    return {
      provide: {
        metrics: metricsInstance,
      },
    };
  },
});
